"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _lodash = require("lodash");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 *  Rates Component
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} returns react element
 */

function Rates(props) {
  var _props$rendering;
  if (!((_props$rendering = props.rendering) !== null && _props$rendering !== void 0 && _props$rendering.fields)) {
    return null;
  }
  var [isLoading, setIsLoading] = (0, _react.useState)(false);
  var [isLoaded, setIsLoaded] = (0, _react.useState)(false);
  var [items, setItems] = (0, _react.useState)([]);
  var displayHeading = "";
  var displayErrMessage = "";
  var displayTitle = "";
  var displayDisclosure = "";

  // data retrieved from Sitecore
  var extractedFields = (0, _utils.extractFieldsFn)(props);

  // retrieve querystring
  var qsCusip = new URLSearchParams(props.params.pageQuery).get('cusip');

  // setup of data for component heading and error message
  displayHeading = extractedFields.Heading.value;
  displayErrMessage = extractedFields.ErrorMessage.value;

  // setup of data specific for the querytring provided
  var ratesInfo = (0, _lodash.find)(extractedFields.RatesList, item => item.fields.CUSIP.value === qsCusip);
  displayTitle = (0, _lodash.get)(ratesInfo, 'fields.FullFundName.value');
  displayDisclosure = (0, _lodash.get)(ratesInfo, 'fields.Disclosure.value');

  // Retrieve the file (using the api) -- data returned is filtered for the cusip from the query string
  if (!(0, _lodash.isEmpty)(qsCusip)) {
    (0, _react.useEffect)(() => {
      setIsLoading(true);
      fetch("/apicalls/rates/?cusip=".concat(qsCusip)).then(res => res.json()).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (result) {
          setIsLoaded(true);
          setItems(result);
          setIsLoading(false);
        });
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), error => {
        setIsLoaded(true);
      });
    }, []);
  }

  // display of table for the cusip in the query string
  var RenderTableSection = () => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
      key: "table-info",
      id: "tableSection"
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
      id: "date"
    }, "Date"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
      id: "daily-lqa-dollar"
    }, "Daily Liquid Assets", /*#__PURE__*/_react.default.createElement("br", null), "($)"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
      id: "daily-lqa-pct"
    }, "Daily Liquid Assets", /*#__PURE__*/_react.default.createElement("br", null), "(%)"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
      id: "weekly-lqa-dollar"
    }, "Weekly Liquid Assets", /*#__PURE__*/_react.default.createElement("br", null), "($)"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
      id: "weekly-lqa-pct"
    }, "Weekly Liquid Assets", /*#__PURE__*/_react.default.createElement("br", null), "(%)"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
      id: "net-shareholder-flow"
    }, "Net Shareholder", /*#__PURE__*/_react.default.createElement("br", null), "Flow"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
      id: "dailynav"
    }, "Daily", /*#__PURE__*/_react.default.createElement("br", null), "Nav"))), /*#__PURE__*/_react.default.createElement("tbody", null, !(0, _lodash.isArray)(items) && /*#__PURE__*/_react.default.createElement("tr", {
      key: "table-loading"
    }, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: 7,
      key: "data-loading"
    }, "Data Loading")), (0, _lodash.isArray)(items) && (0, _lodash.map)(items, (eachRow, key) => {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: key
      }, /*#__PURE__*/_react.default.createElement("td", {
        key: 'date-' + key
      }, eachRow.BUSINESS_DATE), /*#__PURE__*/_react.default.createElement("td", {
        key: 'daily-lqa-dollar-' + key
      }, eachRow.DAILY_LIQUID_ASSETS_DOLLAR_AMOUNT), /*#__PURE__*/_react.default.createElement("td", {
        key: 'daily-lqa-pct-' + key
      }, eachRow.DAILY_LIQUID_ASSETS_PERCENT), /*#__PURE__*/_react.default.createElement("td", {
        key: 'weekly-lqa-dollar-' + key
      }, eachRow.WEEKLY_LIQUID_ASSETS_DOLLAR_AMOUNT), /*#__PURE__*/_react.default.createElement("td", {
        key: 'weekly-lqa-pct-' + key
      }, eachRow.WEEKLY_LIQUID_ASSETS_PERCENT), /*#__PURE__*/_react.default.createElement("td", {
        key: 'net-shareholder-flow-' + key
      }, eachRow.NET_SHAREHOLDER_FLOWS), /*#__PURE__*/_react.default.createElement("td", {
        key: 'dailynav-' + key
      }, eachRow.SHADOWNAV));
    })));
  };

  // displays the name of the fund, cusip, table and disclosure
  var RenderTableTopSection = _ref2 => {
    var {
      RatesList,
      cusip,
      tableData
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      id: "headingSection"
    }, /*#__PURE__*/_react.default.createElement("h2", null, displayTitle), /*#__PURE__*/_react.default.createElement("p", null, "CUSIP ", qsCusip)),
    // if the api call to the file OR there is no content in the component
    // then no information should be returned and a message displayed to the user
    // if there are results from the api call and there is info from sitecore, then show the table
    (0, _lodash.isEmpty)(items) || (0, _lodash.isEmpty)(ratesInfo) ? /*#__PURE__*/_react.default.createElement("div", {
      id: "errorMessage"
    }, displayErrMessage) : isLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Loading.... ") : /*#__PURE__*/_react.default.createElement(RenderTableSection, null), /*#__PURE__*/_react.default.createElement("div", {
      id: "disclsoureSection"
    }, displayDisclosure));
  };

  // display of the funds chosen in content to be displayed on the page
  var RenderTopSection = () => {
    // always show fund items if there are any in the component
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      id: "fundSection",
      className: "mm-spacing"
    }, /*#__PURE__*/_react.default.createElement("h1", null, displayHeading), (0, _lodash.map)(extractedFields.RatesList, (eachRow, key) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: key
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "fundItem"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "?cusip=".concat(eachRow.fields.CUSIP.value)
    }, eachRow.fields.FullFundName.value))))));
  };

  // display of the this component
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(RenderTopSection, null), !(0, _lodash.isEmpty)(qsCusip) ? /*#__PURE__*/_react.default.createElement(RenderTableTopSection, null) : null);
}
var _default = exports.default = Rates;